import React, { useState, useEffect } from 'react';   
import { Avatar, Menu, Drawer, Badge, Dropdown, Button, message } from 'antd';
import { BellOutlined, LogoutOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'; 
import Logout from '../auth/Logout';
import axios from '../../services/axios';
import moment from 'moment'
import { logout } from '../../services/auth';

export default function Header({ auth }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([])
  const [darkMode, setDarkMode] = useState(false);

  const role = JSON.parse(localStorage.getItem('role'));
  const ProjectName = JSON.parse(localStorage.getItem("Project"));

  const showDrawer = () => {
    setVisible(true);
    getNotifications(true)
  }
  const closeDrawer = () => {
    setVisible(false);
    getNotifications();
  }

  const handleLogout = async () => {
    try {
      await logout();   // call backend API
    } catch (error) {
      console.error("Logout failed:", error);
    }

    navigate('/login');
  };

  const getNotifications = async ( isRead ) => {
    try {
			const res = await axios.post('get-unread-notifications', { user: auth.user, isRead, ProjectName });
      if(res && res.data && res.data.notifications){
        setNotifications(res.data.notifications)
      }
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}	
  }

  useEffect(()=>{
    getNotifications()
  }, [])

  const onClickNotification = () => {
    navigate('/home/view-document')
    setVisible(false)
    getNotifications();
  }
 
  return (
    <header className={`sticky top-0 z-50 w-full shadow-md px-6 py-2 transition-all ${darkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-800'}`}>

      <div className="flex flex-wrap items-center justify-between gap-y-3">
        
        <div className="flex items-center gap-3 flex-shrink-0">
          <img src="/cladoc.webp" alt="Citriot Logo" className="h-10 sm:h-12 w-auto object-contain" />
          <span className="text-xs sm:text-sm font-medium text-gray-500">{role ? role[0] : 'Super User'}</span>
        </div>

        <div className="w-full sm:w-auto text-center order-3 sm:order-none">
          <h1 className="text-xl sm:text-2xl font-bold tracking-wide text-blue-700 uppercase">
            {ProjectName}
          </h1>
        </div>

        <div className="flex items-center justify-end gap-4 flex-wrap sm:flex-nowrap">

          <Badge count={notifications.length} size="small">
            <BellOutlined 
              className="text-xl cursor-pointer hover:text-blue-600 transition" 
              onClick={showDrawer} 
            />
          </Badge>

          <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full hover:bg-gray-200 transition cursor-pointer">
            <Avatar className="bg-indigo-600 text-white shadow text-xs">
              {auth?.user?.[0]?.toUpperCase() || 'S'}
            </Avatar>
            <span className="text-xs sm:text-sm font-medium">{auth?.user || 'Super User'}</span>
          </div>

          <Button 
            onClick={handleLogout} 
            type="default" 
            icon={<LogoutOutlined style={{ transform: 'rotate(180deg)' }} />} 
            className="hover:bg-gray-200 rounded-full transition p-1 sm:p-2" 
          />

          {role && role[0] !== 'Super User' && (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="switch" onClick={() => navigate('/landingPage')}>
                    🚀 Switch Project
                  </Menu.Item>
                </Menu>
              }
              trigger={['click']}
            >
              <div className="flex items-center gap-1 text-sm text-gray-600 cursor-pointer hover:text-blue-600 transition">
                <AppstoreOutlined />
                <span className="hidden sm:inline"></span>
              </div>
            </Dropdown>
          )}
        </div>
      </div>

      <Drawer title="Recent Notifications" placement="right" onClose={closeDrawer} open={visible}>
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <div key={index} className="mb-3 p-3 border rounded-lg shadow hover:bg-gray-50 transition cursor-pointer" onClick={onClickNotification}>
              <p className="text-sm font-semibold text-gray-800">{notification.message}</p>
              <p className="text-xs text-gray-500">{moment(notification.createdOn).format('DD-MM-YYYY hh:mm A')}</p>
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center h-28">
            <p className="text-gray-500 font-semibold">No recent notifications</p>
          </div>
        )}
      </Drawer>
    </header>
  );
}
